import * as React from 'react'
import {IMapDispatcher, IExportMapDispatcher} from '../../interfaces/dispatchers'
import {PageSize} from '../../interfaces/models'
import {IExportJob, IExportMap, IExportElements, IStore} from '../../interfaces/reducers'
import OverlayLoader from '../Loading/OverlayLoading'
import merge from 'lodash/merge'
import axios from 'axios'
import {config} from '../../reducers/config'

export interface OwnProps {
  vectorLayerImagesLoaded: boolean
  exportMapStore: IExportMap
  hardLoading: boolean
}

export interface ParentProps {
  pageSizeFilter?: string[]
  hideWithMap?: boolean
  hideDpi?: boolean
  hideLandScape?: boolean
  hideScaleToggle?: boolean
  hideLegendToggle?: boolean
  hideScaleSetter?: boolean
  selectedExport: string
}

export interface DispatchProps extends IExportMapDispatcher, IMapDispatcher {}

export type Props = OwnProps & ParentProps & DispatchProps

export interface State {
  name: string
  temporaryScale: number
  editMode: boolean
}

export class ExportMapControl extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      temporaryScale: 500,
      name: '',
      editMode: false
    }
  }

  componentDidMount() {
    this.props.setPreviewMode(true)
  }
  componentWillUnmount() {
    this.props.setPreviewMode(false)
  }
  componentDidUpdate(prevProps: Props) {
    if (prevProps.exportMapStore.mapProps.scale !== this.props.exportMapStore.mapProps.scale) {
      this.setState({...this.state, temporaryScale: this.props.exportMapStore.mapProps.scale})
    }
  }

  getNameInput(): JSX.Element {
    return (
      <input
        className="form-control"
        value={this.state.name}
        onChange={e => this.setState({...this.state, name: e.target.value})}
      ></input>
    )
  }

  getContainer(content: JSX.Element, title: string): JSX.Element {
    return (
      <div style={{margin: `20px 0px`}}>
        <div>{title}</div>
        <div>{content}</div>
      </div>
    )
  }
  getDpiSelector(): JSX.Element {
    const options: number[] = [150, 300, 600]
    const os: JSX.Element[] = []
    options.forEach((o, i) => {
      os.push(
        <option key={i} value={o}>
          {o}
        </option>
      )
    })
    return (
      <select
        className="form-control"
        onChange={e => {
          this.props.setDPI(parseInt(e.target.value))
        }}
        value={this.props.exportMapStore.dpi}
      >
        {os}
      </select>
    )
  }

  getBackgroundSelector(): JSX.Element {
    return (
      <div>
        <label>С подложка</label>
        <input
          type="checkbox"
          checked={this.props.exportMapStore.useBackground}
          onChange={e => {
            this.props.useBackground(!this.props.exportMapStore.useBackground)
          }}
        ></input>
      </div>
    )
  }

  getScaleSelector(): JSX.Element {
    return (
      <div style={{display: 'flex', justifyContent: 'space-between', width: '170px', alignItems: 'center'}}>
        <select
          className={'form-control'}
          style={{width: '200px'}}
          value={this.state.temporaryScale}
          onChange={e => {
            if (!isNaN(parseFloat(e.target.value))) {
              this.setState({...this.state, temporaryScale: parseFloat(e.target.value)})
              this.props.setScale(parseFloat(e.target.value))
            }
          }}
        >
          <option>Изберете Мащаб</option>
          <option value={500}>1:500</option>
          <option value={1000}>1:1000</option>
          <option value={2000}>1:2000</option>
          <option value={5000}>1:5000</option>
          <option value={10000}>1:10000</option>
          <option value={20000}>1:20000</option>
        </select>
      </div>
    )
  }

  getPageSizeSelector(): JSX.Element {
    const options = Object.keys(PageSize)
    const os: JSX.Element[] = []
    options.forEach((o, i) => {
      if (!this.props.pageSizeFilter || this.props.pageSizeFilter.indexOf(o) != -1) {
        os.push(
          <option key={i} value={o}>
            {o}
          </option>
        )
      }
    })
    return (
      <select
        className="form-control"
        onChange={e => {
          this.props.setPageSize(e.target.value as PageSize, this.props.exportMapStore.landscape)
        }}
        value={this.props.exportMapStore.pageSize}
      >
        {os}
      </select>
    )
  }

  getLandscapeSelector(): JSX.Element {
    const selectRowStyle: React.CSSProperties = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: '10px 0'
    }
    return (
      <div
        style={{
          display: 'flex',
          minHeight: '40px',
          alignItems: 'center'
        }}
      >
        <div style={selectRowStyle}>
          <input
            type="radio"
            value="1"
            name="export-landscape"
            checked={!this.props.exportMapStore.landscape}
            onChange={e => {
              this.props.setPageSize(this.props.exportMapStore.pageSize, !this.props.exportMapStore.landscape)
            }}
          />
          <span>Портрет</span>
        </div>
        <div style={selectRowStyle}>
          <input
            type="radio"
            value=""
            name="export-landscape"
            checked={this.props.exportMapStore.landscape}
            onChange={e => {
              this.props.setPageSize(this.props.exportMapStore.pageSize, !this.props.exportMapStore.landscape)
            }}
          />
          <span>Панорама</span>
        </div>
      </div>
    )
  }

  getNameSelector(): JSX.Element {
    return (
      <input
        value={this.state.name}
        onChange={e => {
          this.setState({...this.state, name: e.target.value})
        }}
      ></input>
    )
  }

  jobsQueues(): JSX.Element {
    let queue: IExportJob[] = []
    const results: JSX.Element[] = []
    for (const key in this.props.exportMapStore.exportJobs) {
      queue.push(this.props.exportMapStore.exportJobs[key])
    }
    queue = queue.sort((a, b) => (a.dateCreated > b.dateCreated ? 1 : -1))
    queue.forEach((q, i) => {
      results.push(
        <div
          key={i}
          style={{
            position: 'relative',
            width: '100%',
            minHeight: '30px',
            padding: '4px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxSizing: 'border-box',
            margin: '8px 0px'
          }}
        >
          <OverlayLoader show={q.loading} />
          {q.error ? (
            <div style={{color: 'red'}}>
              <div>{q.name}</div>
              <div>{q.error.message}</div>
            </div>
          ) : (
            <a href={q.url} target="_blank" rel="noreferrer">
              {q.name}
            </a>
          )}
        </div>
      )
    })
    return (
      <div>
        <h4
          style={{
            textAlign: 'center'
          }}
        >
          Резултати:
        </h4>
        {results.length > 0 ? (
          results
        ) : (
          <div
            style={{
              textAlign: 'center',
              fontStyle: 'italic'
            }}
          >
            Няма създадени карти
          </div>
        )}
      </div>
    )
  }

  printButton(): JSX.Element {
    return (
      <>
        {this.props.exportMapStore.mapProps.scale > 20000 ? (
          <div className="error-div">Мащабът трябва да е под 20000</div>
        ) : null}
        <button
          type="button"
          disabled={!this.state.name || this.props.exportMapStore.mapProps.scale > 20000}
          className="button margin"
          onClick={() => {
            this.props.startJob(this.state.name + '.pdf', message => {
              if (message) {
                alert('Възникна грешка: ' + message)
              }
            })
          }}
        >
          Експорт
        </button>
      </>
    )
  }

  getMarginSetter() {
    return (
      <div style={{display: 'flex'}}>
        <div>
          Връх
          <input
            className="form-control"
            type="number"
            value={(this.props.exportMapStore.margins[0] * this.props.exportMapStore.unitMmFactor).toFixed(0)}
            onChange={e => {
              const newMargins = [...this.props.exportMapStore.margins] as [number, number, number, number]
              newMargins[0] = parseInt(e.target.value) / this.props.exportMapStore.unitMmFactor
              this.props.setMargins(newMargins)
            }}
          ></input>
        </div>
        <div>
          Дясно
          <input
            className="form-control"
            type="number"
            value={(this.props.exportMapStore.margins[1] * this.props.exportMapStore.unitMmFactor).toFixed(0)}
            onChange={e => {
              const newMargins = [...this.props.exportMapStore.margins] as [number, number, number, number]
              newMargins[1] = parseInt(e.target.value) / this.props.exportMapStore.unitMmFactor
              this.props.setMargins(newMargins)
            }}
          ></input>
        </div>
        <div>
          Дъно
          <input
            className="form-control"
            type="number"
            value={(this.props.exportMapStore.margins[2] * this.props.exportMapStore.unitMmFactor).toFixed(0)}
            onChange={e => {
              const newMargins = [...this.props.exportMapStore.margins] as [number, number, number, number]
              newMargins[2] = parseInt(e.target.value) / this.props.exportMapStore.unitMmFactor
              this.props.setMargins(newMargins)
            }}
          ></input>
        </div>
        <div>
          Ляво
          <input
            className="form-control"
            type="number"
            value={(this.props.exportMapStore.margins[3] * this.props.exportMapStore.unitMmFactor).toFixed(0)}
            onChange={e => {
              const newMargins = [...this.props.exportMapStore.margins] as [number, number, number, number]
              newMargins[3] = parseInt(e.target.value) / this.props.exportMapStore.unitMmFactor
              this.props.setMargins(newMargins)
            }}
          ></input>
        </div>
      </div>
    )
  }

  getMapPaparSizes(): JSX.Element {
    const remarkStyle: React.CSSProperties = {
      fontSize: '11px',
      fontStyle: 'italic',
      marginLeft: '10px'
    }
    const valueStyle: React.CSSProperties = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
    return (
      <div>
        <div style={valueStyle}>
          <div style={{color: 'black'}}>{`Дължина карта: ${(
            this.props.exportMapStore.mapProps.mapPaparWh[0] / 10
          ).toFixed(1)} см`}</div>
        </div>
        <div style={valueStyle}>
          <div style={{color: 'black'}}>{`Височина карта: ${(
            this.props.exportMapStore.mapProps.mapPaparWh[1] / 10
          ).toFixed(1)} см`}</div>
        </div>
      </div>
    )
  }

  getLegendAndScaleToggle() {
    let legendsVisible = true
    let scalesVisible = true
    const legends: IExportElements = {}
    const scales: IExportElements = {}
    for (const key in this.props.exportMapStore.elements) {
      if (this.props.exportMapStore.elements[key].type == 'legend') {
        legends[key] = this.props.exportMapStore.elements[key]
        if (this.props.exportMapStore.elements[key].hide) {
          legendsVisible = false
        }
      }
    }
    for (const key in this.props.exportMapStore.elements) {
      if (this.props.exportMapStore.elements[key].type == 'scale') {
        scales[key] = this.props.exportMapStore.elements[key]
        if (this.props.exportMapStore.elements[key].hide) {
          scalesVisible = false
        }
      }
    }
    return (
      <div style={{display: 'flex'}}>
        {this.props.hideLegendToggle ? null : (
          <div style={{display: 'flex', width: '200px'}}>
            <label>С легенда</label>
            <input
              type="checkbox"
              onChange={e => {
                for (const key in legends) {
                  this.props.updateElementProps(key, {...legends[key], hide: !legends[key].hide})
                }
              }}
              checked={legendsVisible}
            ></input>
          </div>
        )}
        {this.props.hideScaleToggle ? null : (
          <div style={{display: 'flex', width: '200px'}}>
            <label>С мащаб</label>
            <input
              type="checkbox"
              onChange={e => {
                for (const key in scales) {
                  this.props.updateElementProps(key, {...scales[key], hide: !scales[key].hide})
                }
              }}
              checked={scalesVisible}
            ></input>
          </div>
        )}
      </div>
    )
  }

  getZoomFactorSetter() {
    return (
      <div style={{display: 'flex'}}>
        <button
          type="button"
          onClick={() => {
            this.props.setZoomFactor(this.props.exportMapStore.zoomFactor - 0.1)
          }}
          className="button"
        >
          -
        </button>
        <input
          readOnly={true}
          className="form-control"
          onChange={e => {}}
          value={this.props.exportMapStore.zoomFactor.toFixed(1)}
        ></input>
        <button
          type="button"
          onClick={() => {
            this.props.setZoomFactor(this.props.exportMapStore.zoomFactor + 0.1)
          }}
          className="button"
        >
          +
        </button>
      </div>
    )
  }

  encodeUnicode(str: string): string {
    return btoa(encodeURIComponent(str))
  }
  decodeUnicode(str: string): string {
    return decodeURIComponent(atob(str))
  }

  persistCustomExports() {
    type ExportData = {
      regular: string
      izvadka: string
      kombinirana: string
      trasirovuchen: string
      izvadka2: string
      prn_izvadka: string
      combined: string
      upicoordinates: string
      visa: string
      custom: string
      [key: string]: string
    }

    const data: ExportData = {
      regular: '',
      izvadka: '',
      kombinirana: '',
      trasirovuchen: '',
      izvadka2: '',
      prn_izvadka: '',
      combined: '',
      upicoordinates: '',
      visa: '',
      custom: ''
    }

    for (const key in data) {
      const customExportsString = localStorage.getItem(key)
      if (customExportsString) {
        data[key] = customExportsString
      }
    }

    axios.post(config.getConfig().urls.xyApiUrl + '/AdminAccount/setCustomExports', data)
  }

  getCustomElements() {
    return (
      <div>
        <div>
          <button
            type="button"
            className={`button ${this.state.editMode ? 'active' : ''}`}
            onClick={() => {
              this.props.setEditMode(!this.state.editMode)
              this.setState({...this.state, editMode: !this.state.editMode})
            }}
          >
            {this.state.editMode ? 'Изключи редакция' : 'Включи редакция'}
          </button>
        </div>

        <div>
          <button
            type="button"
            disabled={!this.state.editMode}
            onClick={() => {
              const temp = {
                [this.props.exportMapStore.pageSize]: {
                  [this.props.exportMapStore.landscape ? 'landscape' : 'portrait']: {
                    elements: this.props.exportMapStore.elements,
                    mapProps: this.props.exportMapStore.mapProps,
                    margins: this.props.exportMapStore.margins,
                    zoomFactor: this.props.exportMapStore.zoomFactor
                  }
                }
              }
              const customExportsString = localStorage.getItem(this.props.selectedExport)
              if (customExportsString) {
                const customExports = JSON.parse(this.decodeUnicode(customExportsString))
                delete customExports[this.props.exportMapStore.pageSize][
                  this.props.exportMapStore.landscape ? 'landscape' : 'portrait'
                ]
                const content = merge({}, temp, customExports)
                const data = this.encodeUnicode(JSON.stringify(content))
                localStorage.setItem(this.props.selectedExport, data)
              } else {
                const content = temp
                const data = this.encodeUnicode(JSON.stringify(content))
                localStorage.setItem(this.props.selectedExport, data)
              }
              const saveStatus = document.getElementById('save_status')
              this.persistCustomExports()
              if (saveStatus) {
                saveStatus.innerText = 'Запазено'
                setTimeout(() => {
                  saveStatus.innerText = 'Запази шаблона'
                }, 2000)
              }
            }}
            className="button"
          >
            <div id="save_status">Запази шаблона</div>
          </button>

          {/* make a download template button */}
          <button
            type="button"
            disabled={this.state.editMode}
            onClick={() => {
              const customExportsString = localStorage.getItem(this.props.selectedExport)
              if (customExportsString) {
                const blob = new Blob([customExportsString], {type: 'application/json'})
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = this.props.selectedExport + '.template'
                a.click()
              }
            }}
            className="button"
          >
            Изтегли шаблона
          </button>
          {/* make input field for upload the downloaded template */}
          <input
            type="file"
            accept=".template"
            onChange={e => {
              if (e.target.files && e.target.files[0]) {
                const file = e.target.files[0]
                const reader = new FileReader()
                reader.onload = event => {
                  const content = event.target?.result
                  if (content) {
                    const data = content.toString()
                    localStorage.setItem(this.props.selectedExport, data)
                    this.persistCustomExports()
                  }
                }
                reader.readAsText(file)
              }
            }}
            className="form-control"
            style={{marginTop: '10px'}}
          ></input>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          overflow: 'auto'
        }}
      >
        <div style={{margin: '20px', position: 'relative'}}>
          <OverlayLoader size="60px" show={this.props.hardLoading}></OverlayLoader>

          <div id="export-results"></div>
          {this.props.hideScaleSetter ? null : this.getContainer(this.getScaleSelector(), 'Изберете мащаб')}
          {this.getContainer(this.getNameInput(), 'Име на файла')}
          {this.getContainer(this.getPageSizeSelector(), 'Изберете формат на печата')}
          {this.props.hideLandScape
            ? null
            : this.getContainer(this.getLandscapeSelector(), 'Изберете формат на печата')}
          {this.props.hideDpi ? null : this.getContainer(this.getDpiSelector(), 'Изберете DPI')}
          {this.getContainer(this.getMarginSetter(), 'Марж (милиметри)')}
          {this.getContainer(this.getZoomFactorSetter(), 'Увеличение')}
          {this.getBackgroundSelector()}
          {this.getLegendAndScaleToggle()}
          {this.printButton()}
          {this.jobsQueues()}
          {this.getCustomElements()}
        </div>
      </div>
    )
  }
}

export const mapStateToProps = (store: IStore) => {
  return {
    vectorLayerImagesLoaded: store.layerInfos.vectorLayerImagesLoaded,
    exportMapStore: store.exportMap,
    hardLoading: store.map.hardLoading,
    editMode: store.editMode
  }
}
